/** @format */
import {useState} from 'react';

import {Grid2 as Grid} from '@mui/material';

import {East} from '@mui/icons-material';

import {Trans} from 'react-i18next';

import {
  DescriptionBox,
  DescriptionText,
  HeadingBox,
  HeadingText,
  LeftBlock,
  Root,
  TextWithIconBox,
} from './styles';
import {AgencyForm} from './AgencyForm';
import {SubmitResult} from './SubmitResult';

const AgencyTariffs = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleSuccess = () => {
    setIsSuccess(true);
  };

  return (
    <Root>
      <Grid container spacing={8}>
        <Grid size={{md: 5, xs: 12}}>
          <LeftBlock>
            <HeadingBox>
              <HeadingText>
                <Trans>Тарифы для диджитал-агентств</Trans>
              </HeadingText>
            </HeadingBox>

            <DescriptionBox>
              <DescriptionText>
                <Trans>
                  Для профессиональных игроков рынка рекламных агентств у нас разработаны
                  специальные условия.
                </Trans>
              </DescriptionText>
              <TextWithIconBox>
                <DescriptionText>
                  <Trans>Чтобы ознакомиться, оставьте заявку</Trans>
                </DescriptionText>
                <East />
              </TextWithIconBox>
            </DescriptionBox>
          </LeftBlock>
        </Grid>

        <Grid size={{md: 7, xs: 12}}>
          {isSuccess ? <SubmitResult /> : <AgencyForm onSuccess={handleSuccess} />}
        </Grid>
      </Grid>
    </Root>
  );
};

export {AgencyTariffs};
